import { getLocalStorageItem, setLocalStorageItem } from "../../utils";
import { WidgetContextState } from "./widgettypes";

const WIDGET_STORAGE_KEY = "widgets";

export const getWidgetStateFromStorage = (): WidgetContextState => {
  return (
    getLocalStorageItem(WIDGET_STORAGE_KEY) || {
      widgets: {},
      counters: {},
      pieCounters: {},
    }
  );
};

export const saveWidgetStateToStorage = (state: WidgetContextState): void => {
  setLocalStorageItem(WIDGET_STORAGE_KEY, state);
};
